import cookie from 'cookie.js'
import { ref } from 'vue'
import  { http } from '@/request/http.js'
import { showNotify } from 'vant';

export const remainSecond = ref(0)

export const sendCode = mobile => {
    console.log(mobile)
    cookie.set('_captcha', Date.now(), { path: '/' })
    remainSecond.value = 60
    setTimer()
    http.post('/app-api/member/auth/send-sms-code', {
        mobile: mobile,
        scene: 0
    }).then(res => {
        showNotify({
            message: '短信发送成功',
            type: 'success'
        })
    }).catch(err => {
        remainSecond.value = 0
    })
}

function setTimer(){
    var timer = setInterval(() => {
        if(remainSecond.value <= 0 ) {
            clearInterval(timer)
            return
        }
        remainSecond.value --
    }, 1000)
}

export function resetSecond(){
    const lastTimeStamp = cookie.get('_captcha', Date.now(), { path: '/' })
    if(lastTimeStamp){
        remainSecond.value = parseInt(Math.max(0, 60 * 1000 - (Date.now() - Number(lastTimeStamp))) / 1000)
        setTimer()
    }
}

export function clearTimer(){
    remainSecond.value = 0
    clearInterval(timer)
}